import { render, staticRenderFns } from "./text-link-new.vue?vue&type=template&id=d8be9f5a&scoped=true&"
import script from "./text-link-new.vue?vue&type=script&lang=js&"
export * from "./text-link-new.vue?vue&type=script&lang=js&"
import style0 from "./text-link-new.vue?vue&type=style&index=0&id=d8be9f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8be9f5a",
  null
  
)

export default component.exports